/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanNameIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanNameIcon({
  children,
  viewPath = "/DesignSystem/Svgs/PlanNameIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "#2E2E2E",
  stroke = "#2E2E2E"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="PlanNameIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-ZkRA9d': alignSelf,'--mt-2-ZkRA9d': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZkRA9d': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZkRA9d': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZkRA9d': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZkRA9d': opacity,'--w-7-ZkRA9d': typeof width === 'number' ? `${width}px` : width,'--h-8-ZkRA9d': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="PlanNameIcon.SvgPath"
  data-view-path={viewPath}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M11.1 10.4h5.6v-.3-4.5c0-.2.1-.5.2-.7.6-1 1.2-2.1 1.8-3.1.4-.6 1-.6 1.3 0 .6 1 1.2 2.1 1.9 3.1 0 .2.1.4.1.6v5h3c1.8 0 3.4 1.6 3.5 3.4v12.9c0 1.2-.4 2.2-1.3 2.9-.6.6-1.4.9-2.3.9h-17c-1.9 0-3.3-.9-4.2-2.6-.3-.6-.4-1.3-.4-1.9V10.3c0-2.2 1.6-4.1 3.8-4.3 1.1-.1 2.1-.1 3.2-.1.3 0 .6.3.6.6V10.1c.2.1.2.2.2.3zm0 1.4v10.4c0 .6-.2.9-.9.9H8c-1.6 0-2.9 1.2-3.1 2.6-.3 2 1.1 3.6 3.2 3.7h16.6c1.5 0 2.5-1 2.5-2.5V14.4c0-1.5-1-2.5-2.5-2.5H22V20.7c-.2 1.1-.8 1.9-2 2.2-1 .3-2 0-2.7-.8-.5-.6-.7-1.2-.7-2v-7.9-.4h-5.5zm-1.4 9.9V7.3H7.5c-.2 0-.4.1-.6.1-1.3.5-2.1 1.6-2.1 3.1v12.4c.1-.1.1-.1.2-.1.8-.7 1.7-1.1 2.8-1.1h1.9zm9.6-18.4c-.4.7-.8 1.3-1.2 2-.1.2-.1.3-.1.5v10.9h2.7V6.3c0-.5-.1-.9-.4-1.4-.3-.5-.6-1-1-1.6zM20.6 18h-2.7c0 .5 0 2.2.1 2.6.1.6.7 1 1.3 1 .6 0 1.2-.5 1.3-1.1.1-.4 0-2.1 0-2.5z"
 style={{'--f-9-ZkRA9d': fill,'--s-10-ZkRA9d': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}